import React from 'react';

import { Stack, StackProps } from '@lyearn/ui';

const CardBody: React.FC<StackProps> = (props) => {
  return <Stack {...props} />;
};

export default CardBody;
